<template>
  <div>
    <v-divider class="mt-3"></v-divider>
    <v-simple-table height="450" id="style-2" class="ticket-table" fixed-header>
      <template v-slot:default>
        <thead>
          <tr>
            <th style="min-width: 100px; max-width: 100px">Người tạo</th>
            <th style="min-width: 150px; max-width: 150px">Ngày tạo</th>
            <th style="min-width: 250px; max-width: 250px">Nhóm ticket</th>
            <th style="min-width: 250px; max-width: 250px">Loại ticket</th>
            <th style="min-width: 150px; max-width: 150px">Trạng thái xử lý</th>
            <th> </th>
          </tr>
        </thead>
        <tbody v-if="dataTicket && dataTicket.length > 0">
          <tr v-for="ticket in dataTicket" :key="ticket._id">
            <td>
              {{ticket.createdBy.username}}
            </td>
            <td>
              {{formatDateBlendedTutor(ticket.createdAt) || "_"}}
            </td>
            <td>
              {{ ticket.template ? ticket.template.groupTicketName : "_" }}
            </td>
            <td>
              {{ ticket.template ? ticket.template.typeTicketName : "_" }}
            </td>
            <td>
              <div
                class="ticket-status-box"
                v-if="ticket.status"
                :style="`background: ${listTicketStatus.find((e) => e.value === ticket.status.name) ? listTicketStatus.find((e) => e.value === ticket.status.name).color : '#000000'}`"
                style="color: white">
                {{ ticket.status.name}}
              </div>
              <div v-else>
                _
              </div>

            </td>
            <td>
              <img @click="handleShowDetail(ticket._id)" src="../assets/ticket-detail-icon.svg" height="16" style="cursor: pointer" width="16" alt="">
            </td>
          </tr>
        </tbody>
        <tr v-else>
          <td :colspan="6" style="padding: 20px 0;">
            <div class="d-flex justify-center align-center flex-column" style="margin-top: 120px">
              <span>
                Học viên hiện tại chưa có ticket !
              </span>
              <img src="../assets/ticket_empty.svg">
            </div>
          </td>
        </tr>
      </template>
    </v-simple-table>
    <div class="mt-2 mb-2">
      <div class="text-right mb-1 mt-2">
        {{ showIndex() }}
        <v-btn
          small
          class="pagination-btn-left"
          @click="
              () => {
                page--;
              }
            "
          :disabled="page == 1"
        >
          <v-icon>mdi-menu-left</v-icon>
        </v-btn>
        <v-btn
          :disabled="(dataTicket.length < limit)"
          small
          class="pagination-btn-right"
          @click="
              () => {
                page++;
              }
            "
        >
          <v-icon>mdi-menu-right</v-icon>
        </v-btn>
      </div>

<!--      <v-pagination-->
<!--        class="ticket-pagination"-->
<!--        v-model="page"-->
<!--        :length="totalPage"-->
<!--        total-visible="10"-->
<!--      ></v-pagination>-->
    </div>
  </div>
</template>

<script>
import { LIST_STATUS_SUPPORT } from '@/modules/student_detail_bt/constant';
import { mapActions, mapState } from 'vuex';
import BlendedCareRepository from '@/services/BlendedCareRepository';
import moment from 'moment';

export default {
  name: 'TicketTab',
  props: {
    contactData: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      LIST_STATUS_SUPPORT,
      page: 1,
      limit: 10,
      dataTicket: [],
      totalPage: 0,
    };
  },
  computed: {
    ...mapState('student_detail_bt', ['customerCode']),
    ...mapState('ticket', ['listTicketStatus']),
  },
  created() {
    this.getListTicket();
    this.getListTicketStatus();
  },
  watch: {
    page() {
      this.getListTicket();
    },
  },
  methods: {
    ...mapActions('ticket', ['getListTicketStatus']),
    showIndex() {
      if (this.dataTicket.length > 0) {
        // eslint-disable-next-line radix
        const maxIndex = this.dataTicket.length < this.limit ? parseInt(this.page - 1) * parseInt(this.limit) + this.dataTicket.length : parseInt(this.page) * parseInt(this.limit);
        // eslint-disable-next-line radix
        return this.dataTicket.length < this.limit ? `${maxIndex - parseInt(this.dataTicket.length) + 1} - ${maxIndex}` : `${maxIndex - parseInt(this.limit) + 1} - ${maxIndex}`;
      }
      return ('0 - 0');
    },
    handleShowDetail(id) {
      window.open(`/ticket?ticketId=${id}`);
    },
    formatDate(date) {
      if (date) {
        return moment(date).format('HH:mm:ss DD/MM/YYYY');
      }
      return '';
    },
    async getListTicket() {
      const loading = this.$loading.show();
      const response = await BlendedCareRepository.getListTicket({
        customerCode: this.type === 'duo' ? this.contactData.code : this.customerCode,
        page: this.page,
        limit: this.limit,
      });
      if (response.message === 'Success') {
        this.dataTicket = response.data;
        // this.totalPage = response.pagination.totalPage;
      }
      loading.hide();
    },
  },
};
</script>

<style scoped lang="scss">
.ticket-table {
  table {
    thead tr th {
      font-size: 14px;
      font-weight: bold;
      color: #777777;
    }
    tbody tr td {
      color: #707070;
    }
  }
}
.ticket-pagination {
  justify-content: end;
}
.ticket-status-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 5px;
  width: fit-content;
}
.pagination-btn-left, .pagination-btn-right {
  max-width: 30px !important;
  min-width: 30px !important;
  background-color: #ffffff !important;
}

.pagination-btn-left i, .pagination-btn-right i {
  color: rgba(0,0,0,.54) !important
}

.pagination-btn-left {
  margin: 0px 5px 2px 10px !important;
}

.pagination-btn-right {
  margin: 0px 10px 2px 5px !important;
}
</style>
